import React  , {useState} from "react";
import {useDispatch,  useSelector} from 'react-redux';

import { useUser } from "../../state/reactquery";
import { modifyDisplaymodal } from "../../state/redux";

import { jsonstatutscontrats } from "../../utils/utils_contratwin";
import ButtonSimple from "../Buttons/ButtonSimple";
import { gotoficheclientgestion } from "../../utils/actions_lead";

import './ModifContrat.scss' ;
const classNames = require('classnames');

const listecompagnies =['ALPTIS','AMIS','APICIL', 'APIVIA','APRIL', 'ASAF-AFPS','CEGEMA','CIPRES VIE','MALAKOFF HUMANIS',
                        'COVERITY','ECA ASSURANCES',  'ENTORIA','FFA', 'FMA', 'GENERALI','GMC', 'GSMC','HARMONIE',
                        'MODULASSUR',  'NÉOLIANE',  'REPAM','SOLLYAZAR', 'SPVIE','SWISSLIFE', 'WAZARI','HENNER',
                        'e','efz', 'efz2','fda'];



const listchamps ={'nom_titulaire':'Nom du titulaire','prenom_titulaire':'Prénom du titulaire','compagnie':'Compagnie','gamme':'Gamme','formule':'Formule','prix':'Prix','num_contrat':'Numéro de contrat','date_effet':'Date d’effet','date_signature':'Date de signature'}  

const champsobligatoires = ['nom_titulaire','prenom_titulaire','compagnie','formule','prix','num_contrat','date_effet']

const jsontypestarifs={'notypetarif':"Non indiqué", 'lineaire20': "Linéaire 20",
                        'lineaire15': "Linéaire 15",'linrenf25': "Linéaire renforcé 25",
                        'precompte30': "Précompte 30",'precompte40': "Précompte 40",}
 

function FormulaireContrat({datacontrat, setDatacontrat}){
     const dispatch = useDispatch() ;
   const {data: user} = useUser(localStorage.getItem('token'))  ;
   const degrerole = user?.role ==="COMMERCIAL"?1:user?.role ==="MANAGER"?2:user?.role ==="GESTION"?3:user?.role ==="ADMIN"?4:5 ;

   const ecran = useSelector(state=>state.display.ecran) ; 
   // Prime Previsionnele
   // Prime reelle

   const [listautocomplete, setListautocomplete] = useState([]) ;
   
    const handleselecttypetarif = (e)=>{setDatacontrat({...datacontrat,'type_tarif': e.target.value })}   

    const divlabelselecttypetarif = ()=>( <div className="containerlabelinput" >
        <div className="contratext_labelinput_label" >Type de Commission</div>
        {<select value={datacontrat.type_tarif||'notypetarif'} className='selectcompgamme' onChange={handleselecttypetarif} >
                    {Object.keys(jsontypestarifs).map((y,i)=><option key={i}  value={y} >{jsontypestarifs[y]}</option>)}
        </select>}
    </div>) ;


   const handleChange =(e)=>{ 
    e.target.id==='compagnie' && setListautocomplete(listecompagnies.filter(x=>x.toLowerCase().indexOf(e.target.value.toLowerCase())===0));
                             (e.target.id==='compagnie' && e.target.value.length===0 ) && setListautocomplete([]);
                             setDatacontrat({...datacontrat,[e.target.id]:e.target.id==='compagnie'?  e.target.value?.toUpperCase() : e.target.value })}

   const handleChangeContrat =(e)=>{setDatacontrat({...datacontrat,'etat_contrat': e.target.value })}                      

    const definecompagnie =(e)=>{  setDatacontrat({...datacontrat,'compagnie': e.target.id }) ; setListautocomplete([])}

    const grplabelinput = (x,label)=>( <div key={x}  className="containerlabelinput" >
                                            <div className="inputtextelabel">{label}  {champsobligatoires.includes(x) && <span className="champobligatoire">*</span>}</div>
                                            {x==='compagnie' &&  <div style={{position:"absolute",backgroundColor:'#FFF', zIndex:2000,top:'69px', left:'0px', width:'320px', maxHeight:'400px', overflowY:'scroll' }} >
                                                                        {listautocomplete.map(x=><div key={x} id={x}  style={{padding:'5px 15px'}} onClick={definecompagnie}  >{x}</div>)}
                                                                </div>}
                                            <input id={x} autoComplete="off"  value={datacontrat[x]||""}
                                                   disabled={ecran !=='ficheclientgestion' && x==='compagnie' }
                                                   type={(x==='date_effet'||x==='date_signature'||x==='date_fincontrat')?"date":"text"}
                                                   onBlur={()=>{setTimeout(()=>{setListautocomplete([])},2000);   }}  onChange={handleChange}   />
                                        </div>) ;

    const changestatutcontrat = () =>( <div   className="containerlabelinput" >
                                            <div className="inputtextelabel">Statut du contrat</div>
                                            <select value={datacontrat.etat_contrat}    className='selectmofistatutcontrat' id='etat_contrat'  onChange={handleChangeContrat} >
                                                        {Object.keys(jsonstatutscontrats).map((y,i)=><option key={i}  value={y} >{jsonstatutscontrats[y]}</option>)}
                                            </select>
                                        </div>);
    const changecommission = ()=>{
       
        const newcommission = datacontrat.commission_compagnie===1?0:1 ;
        setDatacontrat({...datacontrat,'commission_compagnie': newcommission})  ; 
    }

     const gotolead =async(id)=>{dispatch(modifyDisplaymodal(null)) ;gotoficheclientgestion(id);}
    // DEV LUNDI 01 DEC

    return(<> <div className="changecommission"  >
                    <div className="displayflexe">
                    <div className="changecommission_label" >Contrat commissionné : </div>
                    <div className="changecommission_texte" >Non</div>
                    <div id='commission_compagnie' className={classNames({'yescom':datacontrat.commission_compagnie===1} ,{'nocom':datacontrat.commission_compagnie!==1} )} onClick={changecommission}></div> 
                    <div className="changecommission_texte" >Oui</div>
                    </div>
                     <ButtonSimple  texte="Fiche Client"  containerbouton='boutonsimple'  color='bouton_color_orange' size='bouton_size_small'   onclick={()=>gotolead(datacontrat.id_lead)}    disable={false}  />
                </div>
                <div className="modifcontrat_form" >
                    {Object.keys(listchamps).map(x=>( grplabelinput(x,listchamps[x]) ))}
                    {degrerole>2 && <>{grplabelinput('date_fincontrat',"Date de fin du contrat")}
                                    {changestatutcontrat()}
                                    {divlabelselecttypetarif()}
                                    {grplabelinput('prime_prev',"Prime prévisionnelle")}
                                    {grplabelinput('prime_reelle',"Prime réelle")}</>}

                </div> </>)

}


export default FormulaireContrat ;